import { Component, Input, OnInit } from '@angular/core';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { Invoice } from 'src/app/shared/models/invoice.interface';

@Component({
  selector: 'app-export-certificate',
  templateUrl: './export-certificate.component.html',
  styleUrls: ['./export-certificate.component.scss']
})
export class ExportCertificateComponent implements OnInit {
  @Input() invoices: Invoice[] = [];
  @Input() viewMode: string = 'individual';
  @Input() certificates: any[] = [];
  settings: any;

  constructor(private _globalStateService: GlobalStateService) {}

  ngOnInit(): void {
    this._globalStateService.GetSetting().subscribe((res: any) => {
      this.settings = res?.contacts?.english;
    });
  }

  /** Returns certificates if provided, otherwise maps invoices to certificate-shape objects */
  get displayData(): any[] {
    if (this.certificates && this.certificates.length > 0) {
      return this.certificates;
    }
    return this.invoices.map(invoice => ({
      certificate_no: `EXP-${invoice.invoice_number || '000000'}`,
      reference_number: invoice.invoice_number || '',
      registration_no: invoice.vehicle?.car_no || '',
      registration_date: invoice.vehicle?.reg_year && invoice.vehicle?.reg_month
        ? `${invoice.vehicle.reg_year}-${invoice.vehicle.reg_month}` : '',
      first_reg_date: invoice.vehicle?.year && invoice.vehicle?.month
        ? `${invoice.vehicle.year}-${invoice.vehicle.month}` : '',
      makers_serial_number: invoice.vehicle?.chassis_no || '',
      trademark_maker: invoice.vehicle?.make || '',
      model: invoice.vehicle?.model || '',
      engine_model: invoice.vehicle?.engine || '',
      engine_no: (invoice.vehicle as any)?.engine_no || '',
      classification_of_fuel: invoice.vehicle?.fuel_type || '',
      name_of_owner: '',
      address_of_owner: '',
      name_of_user: '',
      address_of_user: '',
      locality_principal_abode: '',
      classification_of_vehicle: '',
      use: '',
      purpose: '',
      type_of_body: invoice.vehicle?.body_type || '',
      fixed_number: invoice.vehicle?.seat_capacity || '',
      maximum_carry: '',
      weight: invoice.vehicle?.weight ? String(invoice.vehicle.weight) : '',
      g_weight: invoice.vehicle?.g_weight || '',
      engine_capacity: '',
      specification_no: '',
      classification_no: '',
      length: invoice.vehicle?.car_length ? String(invoice.vehicle.car_length) : '',
      width: invoice.vehicle?.car_width ? String(invoice.vehicle.car_width) : '',
      height: invoice.vehicle?.car_height ? String(invoice.vehicle.car_height) : '',
      f_weight: '',
      fr_weight: '',
      rf_weight: '',
      r_weight: '',
      export_scheduled_day: '',
      remarks: '',
      latest_owner_name_registration: '',
      date_of_application: '',
      final_date: new Date().toISOString().split('T')[0]
    }));
  }


  formatDate(dateString: string | null): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  formatCurrency(amount: number | null, currency: string | null = 'USD'): string {
    if (!amount || amount === 0) return '';
    const curr = currency || 'USD';
    return `${curr} ${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  // Helper method to get vehicle count for display
  getVehicleCount(invoice: any): number {
    if (this.viewMode === 'merged' && invoice.vehicles) {
      return invoice.vehicles.length;
    }
    return 1;
  }

  // Helper method to safely access nested properties
  safeGet(obj: any, path: string, defaultValue: string = ''): string {
    const value = path.split('.').reduce((current, key) => current?.[key], obj);
    return value || defaultValue;
  }

  // Generate certificate number based on invoice
  getCertificateNumber(invoice: any): string {
    return `EXP-${invoice.invoice_number || '000000'}`;
  }

  // Get current date for certificate
  getCurrentDate(): string {
    return new Date().toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  // Get current day for certificate
  getCurrentDay(): string {
    return new Date().getDate().toString().padStart(2, '0');
  }

  // Get current month for certificate
  getCurrentMonth(): string {
    return (new Date().getMonth() + 1).toString().padStart(2, '0');
  }

  // Get current year for certificate
  getCurrentYear(): string {
    return new Date().getFullYear().toString();
  }
}
